import { render, staticRenderFns } from "./ChatDialog.vue?vue&type=template&id=d26d631e&scoped=true"
import script from "./ChatDialog.vue?vue&type=script&lang=js"
export * from "./ChatDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatDialog.vue?vue&type=style&index=0&id=d26d631e&prod&scoped=true&lang=css"
import style1 from "./ChatDialog.vue?vue&type=style&index=1&id=d26d631e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26d631e",
  null
  
)

export default component.exports